import React, { useEffect, useState } from 'react';
import { Form, Input } from 'antd';
import {
  alphanumericRegex,
  convertArrayToNestedObject,
  regexNumber,
  regexNumberWithNegative,
  regexPhoneNumber
} from 'utils/helpers';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';

import {
  NUMBER_TEXT,
  TEXT,
  PHONE_NUMBER,
  ALPHA_NUMERIC
} from 'constants/Forms';

import './BRFormInputs.less';

const BRFormInputs = ({
  showCounterExceed = false,
  maxCount,
  errorForm,
  acceptNegative = false,
  forceLowerCase = false,
  ...props
}) => {
  const [valueInput, setValueInput] = useState(null);
  const [count, setCount] = useState(valueInput ? valueInput.length : 0);
  const [countExceed, setCountExceed] = useState(false);
  const [showSubTittle, setShowSubTittle] = useState(true);
  const [isFieldHaveValue, setIsFieldHaveValue] = useState(false);

  //todo how we can change FormRef without it
  //todo onkeyDown

  const {
    placeholder,
    showCounter,
    optional,
    formRef,
    disabled,
    intl,
    name,
    type,
    inputTitle,
    subtitle,
    rules,
    step,
    min,
    prefix,
    suffix,
    allowClear,
    onBlur,
    validateTrigger,
    help,
    defaultValue,
    validateStatus,
    autoFocus = false,
    addonAfter,
    hasFeedback,
    className,
    setInputValue,
    customError,
    inputRef = null,
    maxLength,
    initialCount,
    onFocus = () => {},
    onChangeInput = () => {},
    isTextArea = false,
    inputProps,
    handleEnter = () => {}
  } = props;

  const updateFieldValue = (value) => {
    if (Array.isArray(name)) {
      const result = convertArrayToNestedObject(name, value);
      formRef.current.setFieldsValue(result);
    } else {
      formRef.current.setFieldsValue({ [name]: value });
    }
  };

  useEffect(() => {
    if (errorForm) {
      formRef?.current
        ?.validateFields([name])
        .then((er) => {
          setShowSubTittle(true);
        })
        .catch((er) => {
          if (er.errorFields.length > 0) {
            setShowSubTittle(null);
          } else {
            setShowSubTittle(true);
          }
        });
    }
  }, [errorForm, formRef, name]);

  useEffect(() => {
    if (showCounterExceed) {
      setCountExceed(count > maxCount);
    }
  }, [count]);

  useEffect(() => {
    setShowSubTittle(true);
  }, [subtitle]);

  useEffect(() => {
    if (initialCount || initialCount === 0) {
      setCount(initialCount);
    }
  }, [initialCount]);

  useEffect(() => {
    setIsFieldHaveValue(formRef?.current?.getFieldValue([name]));
  }, [formRef?.current]);

  const handleOnNumberChange = (value) => {
    const convertedValue = convertNumber(value);
    if (
      (acceptNegative ? regexNumberWithNegative : regexNumber).test(
        convertedValue
      ) ||
      value.length === 0
    ) {
      updateFieldValue(convertedValue);
      setValueInput(convertedValue);
      setCount(value.length);
    } else {
      updateFieldValue(valueInput);
    }
  };

  const handleOnAlphaNumericChange = (value) => {
    const convertedValue = convertNumber(value).toUpperCase();
    if (alphanumericRegex.test(convertedValue) || value.length === 0) {
      updateFieldValue(convertedValue);
      setValueInput(convertedValue);
    } else {
      updateFieldValue(valueInput);
    }
  };

  const handleOnPhoneNumberChange = (value) => {
    const convertedValue = convertNumber(value?.replace(/\s|-/g, ''));

    if (regexPhoneNumber.test(convertedValue) || value.length === 0) {
      updateFieldValue(convertedValue);
      setValueInput(convertedValue);
    } else {
      updateFieldValue(valueInput);
    }
  };

  const handleOnTextChange = async (evt) => {
    if (forceLowerCase) {
      evt.target.value = evt.target.value.toLowerCase();
    }
    const {
      currentTarget: { value }
    } = evt;
    if (setInputValue) {
      setInputValue(value);
    }
    if (type === NUMBER_TEXT) {
      handleOnNumberChange(value);
    } else if (type === PHONE_NUMBER) {
      handleOnPhoneNumberChange(value);
    } else if (type === ALPHA_NUMERIC) {
      handleOnAlphaNumericChange(value);
    } else {
      formRef?.current.setFieldsValue({ [name]: convertNumber(value) });
      setCount(value.length);
    }
    onChangeInput({ value: evt.target.value });
    await formRef?.current
      ?.validateFields([name])
      .then((er) => setShowSubTittle(true))
      .catch((er) => setShowSubTittle(null));
  };

  const convertNumber = (inputValue) => {
    return inputValue.replace(/[٠-٩]/g, (d) => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
  };
  return (
    <div
      className={classnames('br-forms-new-input', className, {
        [`${className}_with_subtitle`]: subtitle
      })}
    >
      <Form.Item
        className={classnames({
          'br-form-with-sub-title': subtitle
        })}
        validateTrigger
        name={name}
        label={
          <div className="br-form-item-label">
            <div className="br-form-item-label__title">
              <span className="body-medium">{inputTitle}</span>
              {optional && (
                <span className="br-form-optional-label">
                  {intl.formatMessage({
                    id: 'form.optional_label'
                  })}
                </span>
              )}
              {(showCounter ||
                (showCounterExceed && countExceed && isFieldHaveValue)) && (
                <div
                  className={classnames('br-form-count__count-label body', {
                    'br-form-count__count-label-exceed': countExceed
                  })}
                >
                  <div>
                    {<span>{count}</span>}/{maxCount}
                  </div>
                </div>
              )}
            </div>
          </div>
        }
        help={
          customError ? (
            customError
          ) : !!formRef?.current &&
            !formRef?.current?.getFieldsError([name])?.[0]?.errors?.length &&
            !validateStatus &&
            subtitle &&
            showSubTittle ? (
            <span className="br-form-item-label__subtitle body">
              {subtitle}
            </span>
          ) : (
            help
          )
        }
        rules={rules}
        hasFeedback={!!hasFeedback}
        {...props}
      >
        {isTextArea ? (
          <Input.TextArea
            autoFocus={autoFocus}
            disabled={disabled}
            allowClear={allowClear}
            autoComplete={'' + Math.random()}
            onChange={handleOnTextChange}
            placeholder={placeholder || ''}
            autoSize={{
              minRows: 3,
              maxRows: 3
            }}
            maxLength={maxLength}
            ref={inputRef}
            {...inputProps}
          />
        ) : (
          <Input
            autoFocus={autoFocus}
            disabled={disabled}
            type={type === NUMBER_TEXT ? TEXT : type}
            step={step}
            min={min}
            prefix={prefix}
            suffix={suffix}
            autoComplete={'' + Math.random()}
            allowClear={allowClear}
            onChange={handleOnTextChange}
            onBlur={onBlur}
            value={valueInput ? valueInput : null}
            placeholder={placeholder || ''}
            addonAfter={addonAfter}
            ref={inputRef}
            maxLength={maxLength}
            defaultValue={defaultValue}
            onFocus={onFocus}
            onPressEnter={handleEnter}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default injectIntl(BRFormInputs);
